export default `
  query listOrganisations {
    listOrganisations {
      id
      name
      userId
      user {
        id
        firstname
        lastname
      }
      createdAt
      updatedAt
    }
  }
`
